module.exports = __webpack_public_path__ + "assets/img/wifiIcon-green.de771a08.svg";